/**
 * Partner-Experimente im Dashboard, als duenne Schicht ueber dem
 * Experiment-System in src/features/experiments (Zuteilung, Remote-Config
 * FEATURE_FLAGS, Exposures). Siehe dort README.md.
 *
 * Bleibt bestehen, weil Call-Sites ausserhalb von React (Signup-Redirect in
 * auth-container.js, voller Page-Reload) synchron eine Variante brauchen.
 *
 * Varianten heissen hier weiter A, B, C. Ein Experiment laeuft, wenn es in
 * FEATURE_FLAGS mit unit 'partner' angelegt und gestartet ist.
 */
import {
  activeAssignments,
  buildContext,
  getVariantSync
} from '../features/experiments/flags-store'

// ── Experimente im Dashboard ────────────────────────────────
// Die Registry liegt jetzt remote in FEATURE_FLAGS (Pflege im OS-Dashboard).
//
// onboarding_skip, zurückgestellt am 03.08.2026:
// A = Status quo (geführtes Onboarding mit Assistant im Fokus-Modus),
// B = Landung direkt auf „Stelle erstellen".
//
// Warum zurückgestellt: B nimmt die Führung weg, ohne eine Alternative
// anzubieten. Die grüne Zielgruppe legt ohnehin kaum Stellen an. Ohne
// alternative Führung testet B also nur, ob Leute ohne Hilfe scheitern,
// und die Antwort darauf kennen wir. Erst die Führungs-Alternative bauen,
// dann gegen den Status quo testen.
//
// Reaktivieren = in FEATURE_FLAGS ein Experiment onboarding_skip anlegen,
// unit 'partner', Varianten A und B, und starten. Die Verdrahtung (App.js,
// auth-container.js, DiscoverPage.js) bleibt liegen und ist inaktiv, solange
// das Flag fehlt: getVariant gibt dann null zurück, skipsOnboarding damit
// immer false, alle Partner sehen A. Die Zuteilung rechnet jetzt auf 10000
// Buckets statt modulo 2, die alten Gruppen gelten nicht mehr.

// Route, auf der Variante B startet — hier zentral, damit App.js und der
// Signup-Redirect (voller Page-Reload, kein Router) nicht auseinanderlaufen.
export const ONBOARDING_SKIP_ROUTE = '/discover/create-career'

/** Variante eines Partners in einem Experiment, null wenn es nicht läuft. */
export function getVariant(partnerId, experimentKey) {
  if (!partnerId) return null
  return getVariantSync(experimentKey, buildContext({ partnerId }))
}

/**
 * Überspringt dieser Partner das geführte Onboarding? (Variante B des
 * Experiments onboarding_skip.)
 *
 * Semantik-Schicht über getVariant, damit die Call-Sites nicht das Literal 'B'
 * kennen müssen — wird das Experiment beendet, fällt hier eine Zeile weg statt
 * fünf verteilter Vergleiche.
 *
 * Gilt nur für Partner OHNE abgeschlossenes Onboarding: Bestandskunden sollen
 * nicht nachträglich woanders landen, sonst mischt sich Retention-Verhalten in
 * die Aktivierungs-Messung.
 */
export function skipsOnboarding(partnerId, hasCompletedOnboarding) {
  if (hasCompletedOnboarding) return false
  return getVariant(partnerId, 'onboarding_skip') === 'B'
}

/**
 * Alle laufenden Zuteilungen als Event-Properties (exp_<key>: 'A'). Gilt für
 * Partner-, User- und Besucher-Experimente, Kontext aus den Singletons.
 */
export function experimentProps() {
  const props = {}
  Object.entries(activeAssignments()).forEach(([key, variant]) => {
    props[`exp_${key}`] = variant
  })
  return props
}
